import React from 'react';
import { Box, Typography } from '@mui/material';
import { DOCUMENT, documentEyebrowSx, pageShellSx } from '../constants/documentTheme';

const WRAP_SX = {
  ...pageShellSx,
  boxSizing: 'border-box',
};

const DocumentMarketingHero = ({
  eyebrow,
  title,
  subtitle,
  subtitleDetail,
  disclaimer,
  children,
  align = 'center',
  wide = false,
  testId = 'document-marketing-hero',
}) => (
  <Box
    data-testid={testId}
    sx={{
      bgcolor: DOCUMENT.nav,
      color: DOCUMENT.ivory,
      borderTop: `1px solid ${DOCUMENT.navRule}`,
      borderBottom: `1px solid ${DOCUMENT.navRule}`,
      py: { xs: 4, md: 5.5 },
    }}
  >
    <Box sx={{ ...WRAP_SX, textAlign: align }}>
      {eyebrow && (
        <Typography sx={{ ...documentEyebrowSx, color: DOCUMENT.navAccent, mb: 1 }}>
          {eyebrow}
        </Typography>
      )}
      <Typography
        component="h1"
        sx={{
          fontFamily: DOCUMENT.display,
          fontWeight: 400,
          fontSize: { xs: 28, sm: 36, md: 44 },
          lineHeight: 1.12,
          color: '#FFF8EE',
          letterSpacing: '-0.01em',
        }}
      >
        {title}
      </Typography>
      {disclaimer && (
        <Typography
          sx={{
            mt: 1.25,
            fontSize: { xs: 12, md: 13 },
            lineHeight: 1.5,
            color: 'rgba(246,239,228,.56)',
            maxWidth: wide ? 720 : align === 'center' ? 640 : 560,
            mx: align === 'center' ? 'auto' : 0,
          }}
        >
          {disclaimer}
        </Typography>
      )}
      {subtitle && (
        <Typography
          sx={{
            mt: 1.5,
            fontSize: { xs: 14, md: 16 },
            lineHeight: 1.65,
            color: 'rgba(246,239,228,.72)',
            maxWidth: wide ? 720 : align === 'center' ? 640 : 560,
            mx: align === 'center' ? 'auto' : 0,
          }}
        >
          {subtitle}
        </Typography>
      )}
      {subtitleDetail && (
        <Typography
          sx={{
            mt: 1.25,
            fontSize: { xs: 14, md: 16 },
            lineHeight: 1.65,
            color: 'rgba(246,239,228,.72)',
            maxWidth: wide ? 720 : align === 'center' ? 640 : 560,
            mx: align === 'center' ? 'auto' : 0,
          }}
        >
          {subtitleDetail}
        </Typography>
      )}
      {children && <Box sx={{ mt: 3 }}>{children}</Box>}
    </Box>
  </Box>
);

export default DocumentMarketingHero;
